import CustomDialog from "components/CustomDialog";
import ProductVideos from "pages/products/ProductVideos";
import React from "react";

const ProductVideoInDialog = ({ open, handleClose, product }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading={
        product.videos.length > 0
          ? "Update product videos"
          : "Add product videos"
      }
    >
      <ProductVideos product_id={product.id} fullGrid={true} />
    </CustomDialog>
  );
};

export default ProductVideoInDialog;
